import React from "react"
import "./index.css"

const SocialIcons = () => {
  return (
    <section id="social-icon-sticky mt-auto">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ul className="sticky-social">
              <li>
                <a href="/" target="_blank">
                  <i className="fa fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="/" target="_blank">
                  <i className="fa fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="/" target="_blank">
                  <i className="fa fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="/" target="_blank">
                  <i className="fa fa-tripadvisor"></i>
                </a>
              </li>
              <li>
                <a href="/" target="_blank">
                  <i className="fa fa-youtube-play"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SocialIcons
